"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeTileLayoutStyling = function (_a) {
    var _b, _c, _d;
    var tileCount = _a.tileCount;
    var theme = (0, react_1.useTheme)();
    var _e = theme.breakpoints.values, desktopLarge = _e.desktopLarge, desktopMedium = _e.desktopMedium, mobileMedium = _e.mobileMedium, tabletMedium = _e.tabletMedium, tabletSmall = _e.tabletSmall;
    return {
        root: (0, react_1.css)({
            '&.MuiGrid-spacing-xs-1': (_b = {
                    margin: '0 auto',
                    width: '100%'
                },
                _b[theme.breakpoints.up('desktopLarge')] = __assign(__assign({}, ((tileCount === 9 ||
                    tileCount === 8 ||
                    tileCount === 7 ||
                    tileCount === 4) && {
                    maxWidth: 1080,
                })), ((tileCount === 6 || tileCount === 5 || tileCount === 3) && {
                    maxWidth: 700,
                })),
                _b[theme.breakpoints.between(tabletMedium, desktopLarge)] = __assign(__assign({}, (tileCount === 4 && {
                    maxWidth: 500,
                })), ((tileCount === 9 ||
                    tileCount === 8 ||
                    tileCount === 7 ||
                    tileCount === 6 ||
                    tileCount === 5 ||
                    tileCount === 3) && {
                    maxWidth: 700,
                })),
                _b[theme.breakpoints.between(tabletSmall, tabletMedium)] = __assign(__assign({}, (tileCount === 4 && {
                    maxWidth: 350,
                })), ((tileCount === 9 ||
                    tileCount === 8 ||
                    tileCount === 7 ||
                    tileCount === 6 ||
                    tileCount === 5 ||
                    tileCount === 3) && {
                    maxWidth: 600,
                })),
                _b[theme.breakpoints.down(tabletSmall)] = {
                    maxWidth: 350,
                },
                _b),
            '&.MuiGrid-spacing-xs-1 > .MuiGrid-item': (_c = {},
                _c[theme.breakpoints.up('desktopLarge')] = {
                    padding: 10,
                },
                _c[theme.breakpoints.between(desktopMedium, desktopLarge)] = {
                    padding: 10,
                },
                _c[theme.breakpoints.between(tabletMedium, desktopMedium)] = {
                    padding: 7.5,
                },
                _c[theme.breakpoints.between(tabletSmall, tabletMedium)] = {
                    padding: 6.5,
                },
                _c[theme.breakpoints.between(mobileMedium, tabletSmall)] = {
                    padding: 6,
                },
                _c[theme.breakpoints.down(mobileMedium)] = {
                    padding: 5,
                },
                _c),
        }),
        tileContainer: (0, react_1.css)((_d = {
                minHeight: 87,
                height: '100%',
                width: 118,
                margin: 'auto'
            },
            _d[theme.breakpoints.up('mobileMedium')] = {
                width: 132,
                minHeight: 97,
            },
            _d[theme.breakpoints.up('mobileLarge')] = {
                width: 139,
                minHeight: 102,
            },
            _d[theme.breakpoints.up('tabletSmall')] = __assign({ width: 142, minHeight: 105 }, (tileCount === 2 && {
                width: 190,
                minHeight: 140,
                '& img': {
                    height: 59,
                },
            })),
            _d[theme.breakpoints.up('tabletMedium')] = __assign({ width: 183, minHeight: 135 }, (tileCount === 2 && {
                width: 220,
                minHeight: 162,
                '& img': {
                    height: 68,
                },
            })),
            _d[theme.breakpoints.up('desktopMedium')] = __assign({ width: 209, minHeight: 154 }, (tileCount === 2 && {
                width: 240,
                minHeight: 177,
                '& img': {
                    height: 75,
                },
            })),
            _d[theme.breakpoints.up('desktopLarge')] = __assign({}, (tileCount === 2 && {
                width: 250,
                minHeight: 184,
                '& img': {
                    height: 78,
                },
            })),
            _d)),
        imgDiv: (0, react_1.css)({
            display: 'flex',
            justifyContent: 'center',
        }),
    };
};
exports.default = makeTileLayoutStyling;
//# sourceMappingURL=makeTileLayoutStyling.js.map